enum CreativesTableColumns {
  CREATIVE_NAME = 'name',
  CREATIVE_ID = 'beeswaxId',
  THUMBNAIL = 'thumbnail',
  TYPE = 'type',
  PLATFORM = 'platform',
  CLIENT = 'clientName',
  ADVERTISER = 'advertiserName',
  LINE_ITEMS = 'lineItemsCount',
  STATUS = 'status',
  UPDATED_AT = 'updatedAt',
}

export default CreativesTableColumns;
